import { render, staticRenderFns } from "./streaming.vue?vue&type=template&id=083cdfd7&scoped=true"
import script from "./streaming.vue?vue&type=script&lang=js"
export * from "./streaming.vue?vue&type=script&lang=js"
import style0 from "./streaming.vue?vue&type=style&index=0&id=083cdfd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083cdfd7",
  null
  
)

export default component.exports